define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var I18n = require('i18n!nls/main');

    var mainTpl = require('text!tmpls/parts/notepad/main.tpl').default;
    var itemTpl = require('text!tmpls/parts/notepad/notepad_item.tpl').default;
    var itemOpenTpl = require('text!tmpls/parts/notepad/notepad_item_open.tpl').default;
    var Collection = require('collections/notepad');
    var HeaderModel = require('models/header_alerts');

    var NotepadModel = require('models/notepad');
    var ts = require('system/libs/timestamp2');

    var Config = require('config/application');

    var NotepadItem = Marionette.ItemView.extend({
        template: itemTpl,
        className: 'b-nd__note_block'
    });
    var NotepadCollectionView = Marionette.CollectionView.extend({
        childView: NotepadItem
    });
    var NotepadItemOpen = Marionette.ItemView.extend({
        template: itemOpenTpl,
        className: 'b-nd-open hide',

        events: {
            'keyup textarea': 'buttonPressed'
        },

        _wasButtonPressed: true,
        _intervalButton: 0,
        _intervalSave: 0,
        _isFirst: true,
        _previousValue: '',

        onShow: function () {
            var self = this;

            self._intervalSave = window.setInterval(function () {
                self.save();
            }, 500);
        },

        initInterval: function () {
            var self = this;

            self._intervalButton = window.setInterval(function () {
                self._wasButtonPressed = false;
            }, 1000);
        },

        buttonPressed: function () {
            this._wasButtonPressed = true;
            this.model.set({title: this.$('textarea').val()});

            if (this._isFirst) {
                this._isFirst = false;
                this.initInterval();
            }
        },

        save: function () {
            if (this._wasButtonPressed) return;
            if (_.isEmpty(this.model.get('title'))) return;
            if (this.model.get('title') === this._previousValue) return;

            this._previousValue = this.model.get('title');
            this.model.save(this.collection, {}, false);
            this._wasButtonPressed = true;
        },

        onDestroy: function () {
            window.clearInterval(this._intervalButton);
            window.clearInterval(this._intervalSave);
        }
    });
    var EmptyView = Marionette.ItemView.extend({
        template: I18n.notepad.no_notes,
        className: 'text-center p-b-5 p-t-15 b-nd__no_notes lpt-grey'
    });


    return Marionette.LayoutView.extend({
        template: mainTpl,

        regions: {
            regionNote: '#js-notepad-region-notes',
            regionNoteOpen: '#js-notepad-region-open-note'
        },

        ui: {
            'btnTasks': '.js-btn-tasks-inner',
            'openNote': '.js-notepad-open',
            'closeNote': '.js-notepad-back',
            'addNote': '.js-notepad-add-new',
            'deleteNote': '.js-notepad-delete',
            'wrapper': '.js-window-wrapper',
            'scroll': '.js-scroll'
        },

        events: {
            'click @ui.btnTasks': 'showTasks',
            'click @ui.openNote': 'openNote',
            'click @ui.closeNote': 'closeNote',
            'click @ui.addNote': 'addNote',
            'click @ui.deleteNote': 'deleteNote',
            'mouseenter @ui.wrapper': 'disableBodyScroll',
            'mouseleave @ui.wrapper': 'enableBodyScroll'
        },

        _animSpeed: 400,
        _noteState: '',
        lastScrollTop: 0,

        initialize: function () {
            var that = this;

            this.headerModel = new HeaderModel();
            this.collection = new Collection();
            this.listenTo(this.headerModel, 'sync', this.afterSync);
            this.listenTo(this.collection, 'remove', this.checkAndShowView);

            this.listenTo(app.Vents, 'notepad:modelAdded', function (modelData) {
                that.showOpenNote(parseInt(modelData.id), true)
            });
        },

        onShow: function () {
            app.Temp.NotesView = this;
            this.listenTo(this.collection, 'reset', this.render, this);
            $('#right-sidebar').children('div').addClass('notepadBackground');
            this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            if (this.isFirefox) {
                this.$('#js-notepad-region-notes > div').addClass('ff-b-nd-scroll')
            }

            setTimeout(() => {
                this.$('.js-window-wrapper.scroll-wrapper').css('height', 'calc(100vh - 60px)');
            }, 1000);

            this.headerModel.fetch();
        },

        onRender: function () {
            this.checkAndShowView();
            this.ui.scroll.prop('style', 'overflow-y: auto !important;');
        },

        afterSync: function() {
            this.collection.reset(this.headerModel.get('notes'));
        },

        checkAndShowView: function () {
            if (this.collection.length !== 0) {
                this.sortCollection();
                this.regionNote.show(new NotepadCollectionView({collection: this.collection}));
            } else {
                this.$('div').removeClass('b-nd__scroll scrollbar-macosx');
                this.regionNote.show(new EmptyView());
            }
            this.$el.lptSetter();
        },

        disableBodyScroll: function () {
            var that = this;
            this.lastScrollTop = $(window).scrollTop();
            $(window).scroll(function () {
                window.scrollTo(0, that.lastScrollTop);
            });
        },

        enableBodyScroll: function () {
            this.lastScrollTop = 0;
            $(window).off('scroll');
        },

        showTasks: function (e) {
            e.preventDefault();
            $.cookie('LPT_right-sidebar', 'tasks');
            app.regionRightSidebar.show(new app.Sidebars.Tasks());
            $('#right-sidebar').children('div').addClass('animated fadeIn');
        },

        openNote: function (event) {
            var id = $(event.currentTarget).data('id');
            // this.$('#js-notepad-region-open-note').show();
            this.showOpenNote(id);
        },

        showOpenNote: function (id, isNew) {
            var that = this;
            isNew = isNew || false;
            this.lastNoteModel = this.collection.get(id);
            if (!this.lastNoteModel) return;
            if (isNew) this.lastNoteModel.set({title: ''});
            this._noteState = this.lastNoteModel.get('title');
            this.lastNoteView = new NotepadItemOpen({model: this.lastNoteModel});
            this.regionNoteOpen.show(this.lastNoteView);
            this.$('.b-nd-open').removeClass('hide').addClass('animated-' + this._animSpeed + ' slideInRight');


            this.wrapperStyle = this.ui.wrapper.attr('style');
            this.scrollTopPosition = this.ui.wrapper.scrollTop();
            this.ui.wrapper.attr('style', this.wrapperStyle + 'overflow-y:hidden !important;');
            this.$('.scroll-wrapper.chat-window-wrapper').addClass('chat-window-wrapper--opened-note');
            // this.$('.js-notepad-text-note').scrollbar();
            setTimeout(function () {
                this.ui.wrapper.scrollTop(0);
                this.$('.js-notepad-text-note').css('height', 'calc(100vh - 120px)');
                this.$('#js-notepad-region-open-note').css('height', 'calc(100vh - 120px)');
                $(window).on('keyup', this.switchNote.bind(this));
            }.bind(this), 400);
        },

        switchNote: function (e) {
            if (e.keyCode != 34 && e.keyCode != 33) return;
            e.preventDefault();
            e.stopPropagation();
            var indexOfModel = this.collection.indexOf(this.lastNoteModel);

            if (e.keyCode == 33) { // pageUp
                indexOfModel++;
            } else {               // pageDown
                indexOfModel--;
            }

            if (indexOfModel == -1 || indexOfModel == this.collection.length) return;

            this.lastNoteModel = this.collection.at(indexOfModel);
            if (!this.lastNoteModel) {
                return;
            }

            this.lastNoteView.model = this.lastNoteModel;
            this.lastNoteView.render();
            this.$('.js-notepad-text-note').css('height', 'calc(100vh - 120px)');
            this.$('#js-notepad-region-open-note').css('height', 'auto');
            this.$('.b-nd-open').attr('style', 'top: 40px !important');
        },

        sortCollection: function () {
            var sortedCollection = _.sortBy(this.collection.toJSON(), function (note) {
                return ts(note.date);
            });

            this.collection.reset(sortedCollection.reverse(), {silent: true});
        },

        closeNote: function (e) {
            var that = this;

            var id = $(e.currentTarget).data('id');
            var model = this.collection.get(id);

            /** @var {string} text_note */
            var text_note = this.$('textarea.js-notepad-text-note').val();
            this.$('.js-notepad-text-note').scrollbar('destroy');
            var date = app.Utils.moment().format(Config.locale.date_format + ' ' + Config.locale.time_format_min);

            var head = (text_note.split("\n")) ? text_note.split("\n")[0] : '';
            model.set({title: text_note, date: date, head: head});


            if (model.get('title') !== '') {
                if (this._noteState !== model.get('title')) {
                    model.save(this.collection);
                    this.sortCollection();
                }
            } else {
                model.destroy();
            }


            that.regionNote.show(new NotepadCollectionView({collection: this.collection}));
            this.$('.b-nd-open').addClass('animated-' + this._animSpeed + ' slideOutRight');
            this.ui.wrapper.attr('style', this.wrapperStyle).scrollTop(this.scrollTopPosition);
            this.$('.scroll-wrapper.chat-window-wrapper').removeClass('chat-window-wrapper--opened-note');
            $(window).off('keyup', this.switchNote.bind(this));
            // setTimeout(function () {
            //     that.$('#js-notepad-region-open-note').hide();
            // }, this._animSpeed);
        },

        addNote: function () {
            // $('#js-notepad-region-open-note').show();
            var date = app.Utils.moment().format(Config.locale.date_format + ' ' + Config.locale.time_format_min);
            var model = new NotepadModel();

            model.set({
                title: I18n.notepad.new_note,
                date: date
            });

            model.save(this.collection, {
                success: 'Заметка создана',
                error: 'Заметка не создана'
            });
        },

        deleteNote: function (e) {
            var that = this;

            app.message.confirm(I18n.notepad.delete_node, function () {
                var id = $(e.currentTarget).data('id');

                $(e.currentTarget).closest('.b-nd__note_block').addClass('animated-' + that._animSpeed + ' fadeOut').hide(that._animSpeed);

                setTimeout(function () {
                    var model = this.collection.get(id);
                    if (model) {
                        model.destroy({
                            success: 'Заметка удалена',
                            error: 'Заметка не удалена'
                        });
                    }
                }, that._animSpeed);
            });
        },

        onDestroy: function () {
            this.collection.off('reset remove');
            app.Vents.off('notepad:modelAdded');
        }
    });

});
